import { embedDescriptionContainer, embedDescriptionParagraph } from './GenericEmbedDescription.css';
import type { TPostGenericEmbedDescriptionProps } from './GenericEmbedDescription.types';

export const PostGenericEmbedDescription = ({ element }: TPostGenericEmbedDescriptionProps) => {
  if (!element?.content?.[0]?.text) {
    return null;
  }

  return (
    <div className={embedDescriptionContainer}>
      <p className={embedDescriptionParagraph}>{element.content[0].text}</p>
    </div>
  );
};
